import './App.scss';
import { useState, useEffect } from 'react';
import Game from './Game';
import quizz from "./quizz.json";
import { motion } from 'framer-motion';

function App() {

  const [Homescreen,setHomescreen] = useState(true);

  const [newQuizz,setNewQuizz] = useState();

  const [difficulty,setDifficulty] = useState(false);

  useEffect(() => { 
      let test;
      for (let i = quizz.length -1; i > 0; i--) {
              let j = Math.floor(Math.random() * i)
              let k = quizz[i]
              quizz[i] = quizz[j]
              quizz[j] = k
              test = quizz 
      }
      setNewQuizz(test.slice(0,4));
  },[]);

  function handlingRestart(){
    setHomescreen(true);
  }

  function handleDifficulty(){
    setDifficulty(!difficulty)
  }


  return (
  <>
      <div className="title">
        <h1 style={{'margin':'1rem'}}>ChronoloQuizz</h1>
      </div>
      {Homescreen && 
      <>
        <motion.div
        initial={{opacity:0}}
        animate={{opacity:1}}
        transition={{duration:0.75, ease:'easeIn'}}
        >
          <div className='rules'>
            <h2 style={{'color':'darkorange'}}>Comment jouer ?</h2>
            <p>L'objectif du jeu est de mettre dans l'ordre chronologique différents évènements de l'histoire française.</p>
            <p>Ces évènements sont séparés en plusieurs thèmes.</p>
            <p>A l'aide de la souris, placez les évènements et cliquez sur le bouton pour valider votre choix.</p>
            <p style={{'color':'green'}}>Si c'est correct, vous passez a l'ère historique suivante et vous reprenez 2 vies supplémentaires.</p>
            <p style={{'color':'red'}}>Si c'est incorrect, vous perdrez une vie et vous devrez retenter de mettre dans l'ordre chronologique les évènements.</p>
            <p>Faites attention, car au bout de 4 vies perdues, le jeu est terminé.</p>
            <p style={{'color':'cornflowerblue'}}>Chaque partie est différente, les thèmes et les évènements sont choisis alétoirement !</p>
            <h3 style={{'color':'darkorange'}}>Bonne chance !</h3>
            
            <div className='changeDifficulty'>
              <h3>Mode facile ?</h3>
              <div className="checkbox-wrapper-17">
              <input type="checkbox" id="switch-17" checked={difficulty} onChange={handleDifficulty} /><label htmlFor="switch-17"></label>
              </div>
            </div>
            <div className='toDisplay' style={{'visibility': difficulty ? 'visible' : 'hidden'}}><p>Le mode facile vous fait commencer avec 6 vies au lieu de 4, et vous reprenez 4 vies après chaque manche.</p></div>
          </div>


        </motion.div>
        <motion.div
        initial={{opacity:0}}
        animate={{opacity:1}}
        transition={{delay:0.85, ease:'easeIn'}}
        >
        <div className="homescreen" onClick={()=> setHomescreen(false)}> 
          <h2>Commencer le quizz</h2>
        </div>
        {Homescreen && <p style={{'textAlign':'center', 'color':'white'}}>Fait par <a style={{'color':'mediumspringgreen', 'textDecoration': 'none'}} target="_blank" href='https://guillaumeguichard.dev/' rel="noopener noreferrer"> <img style={{width:'20px', height:'20px', position:'relative', top:'3px', marginRight:'4px'}} src="/logogg.png" alt=""></img>Guillaume Guichard 🔗</a></p>}
        </motion.div>
        </>
      }

      {!Homescreen && 
        <Game quizz={newQuizz} easy={difficulty} handlingRestart={handlingRestart}></Game>
      }


  
  </>
  );
}

export default App;
